import React, { createContext, ReactNode, Context } from 'react';
import { HotTableStoreActions, HotTableStoreState } from './hotTableStoreTypes';
import { Store, UnknownAction } from 'redux';
import { Provider, ReactReduxContextValue } from 'react-redux';

export const HotTableStoreContext = createContext<ReactReduxContextValue<HotTableStoreState, HotTableStoreActions>>(
    {} as ReactReduxContextValue<HotTableStoreState, HotTableStoreActions>,
);

type HotTableStoreProviderProps = {
    store: Store<HotTableStoreState, HotTableStoreActions>;
    children: ReactNode;
};

export const HotTableStoreProvider: React.FC<HotTableStoreProviderProps> = ({ store, children }) => (
    <Provider
        store={store}
        context={HotTableStoreContext as unknown as Context<ReactReduxContextValue<HotTableStoreState, UnknownAction>>}
    >
        {children}
    </Provider>
);
